module.exports = __webpack_public_path__ + "static/3-c5347e6521373d6456072e62d9249d26.jpg";